module.exports = __webpack_public_path__ + "static/media/2 (6).5d708806.jpg";